import { render } from "./Windows.vue?vue&type=template&id=88558d70"
import script from "./Windows.vue?vue&type=script&lang=js"
export * from "./Windows.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__